import React, { useEffect, useState } from 'react';
import { Button, Input, InputNumber, Space } from 'antd';

export const NameFilter: React.FC<{
  value?: string;
  apply: (value?: string) => void;
  close: () => void;
}> = ({ value, apply, close }) => {
  const [draft, setDraft] = useState(value || '');
  useEffect(() => setDraft(value || ''), [value]);
  const submit = (value?: string) => {
    apply(value);
    close();
  };
  return (
    <div style={{ padding: 12 }} onKeyDown={e => e.stopPropagation()}>
      <Input
        aria-label="Filter characterization name"
        placeholder="Name contains…"
        value={draft}
        onChange={e => setDraft(e.target.value)}
        onPressEnter={() => submit(draft.trim() || undefined)}
        maxLength={200}
      />
      <Space style={{ marginTop: 8 }}>
        <Button onClick={() => submit(draft.trim() || undefined)}>Apply</Button>
        <Button onClick={() => submit()}>Reset</Button>
      </Space>
    </div>
  );
};

export const StudyCountFilter: React.FC<{
  min?: number;
  max?: number;
  apply: (min?: number, max?: number) => void;
  close: () => void;
}> = ({ min, max, apply, close }) => {
  const [lo, setLo] = useState<number | null>(min ?? null);
  const [hi, setHi] = useState<number | null>(max ?? null);
  useEffect(() => {
    setLo(min ?? null);
    setHi(max ?? null);
  }, [min, max]);
  const invalid = lo != null && hi != null && lo > hi;
  return (
    <div style={{ padding: 12 }} onKeyDown={e => e.stopPropagation()}>
      <Space>
        <InputNumber
          aria-label="Minimum study count"
          min={0}
          precision={0}
          placeholder="Min"
          value={lo}
          onChange={setLo}
        />
        <InputNumber
          aria-label="Maximum study count"
          min={0}
          precision={0}
          placeholder="Max"
          value={hi}
          onChange={setHi}
        />
      </Space>
      {invalid && <p role="alert">Minimum count must not exceed maximum.</p>}
      <div style={{ marginTop: 8 }}>
        <Space>
          <Button
            disabled={invalid}
            onClick={() => {
              apply(lo ?? undefined, hi ?? undefined);
              close();
            }}
          >
            Apply
          </Button>
          <Button
            onClick={() => {
              apply();
              close();
            }}
          >
            Reset
          </Button>
        </Space>
      </div>
    </div>
  );
};
